import { ITEM_DEFINITION_CODES, STATES } from '../../constants';
import { selectors } from '../../state';
import { track, ERROR } from '@updater-core/lib/tracker';
import { isFeatureEnabled } from '@updater-core/lib/optimizely';
import { TITLE } from './new-product-intro.constants';

export function NewProductIntroConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.NEW_PRODUCT_INTRO, {
    url: '/product-intro?code',
    views: {
      '@': {
        template: `<upd-new-product-intro title="'${TITLE}'"></upd-new-product-intro>`,
        controller: ($element, $state, overrideState) => {
          'ngInject';
          if (overrideState && overrideState.state) {
            const { state, variables = {} } = overrideState;

            $state.go(
              state,
              {
                fromProductIntro: true,
                ...variables,
              },
              { location: 'replace' }
            );
          } else {
            // If there’s no redirect, then the app loads here 💩
            $element[0].dispatchEvent(
              new Event('upd-app-loaded', { bubbles: true })
            );
          }
        },
      },
    },
    scrollTop: true,
    disableBreadcrumb: true,
    analytics: {
      page: 'New Product Intro',
    },
    data: {
      permissions: 'signedIn',
    },
    resolve: {
      overrideState: function (updStore, $stateParams) {
        'ngInject';
        return getNextState(updStore, $stateParams);
      },
    },
  });
}

// LEGACY signed-up route code. For now this needs
// ngAnnotate didn't like this function so it's broken out on its own to
// simplify things.
async function getNextState(updStore, $stateParams) {
  const { code = ITEM_DEFINITION_CODES.HOME_SERVICE_APP } = $stateParams;

  const isForcedIntoProductIntro = await isFeatureEnabled(
    'Product_Intro_Force'
  );

  if (isForcedIntoProductIntro) {
    return null;
  }

  // Allows deep-linking directly into steps [ch22873].
  // If the `code` query param is present, try transitioning to the
  // associated item definition state, if available to the mover.
  // By default, we send users to TV/Internet (colloquially known as “The Firehose”)
  // If it fails, just carry on as usual.
  try {
    const state = selectors.itemDefinition
      .byCode(code)
      .uiState(updStore.getState());
    return state && state.name
      ? {
          state: state.name,
          variables: {
            showIntroBanner: true,
          },
        }
      : null;
  } catch (err) {
    track({
      object: 'product_intro_deep_linking',
      verb: ERROR,
      details: {
        message: err.message,
        stack: err.stack,
      },
    });
    return null;
  }
}
